import { mapCompletionStatus } from "../../common/mapperServices/mapCompletionStatus";
import { type ContentItem, type SearchResult } from "../../AssetResults/types";

export function mapToContentItems(searchResults: SearchResult[]): ContentItem[] {
  return searchResults.map(mapToContentItem);
}

export function mapToContentItem(searchResult: SearchResult): ContentItem {
  return {
    ...searchResult,
    id: parseInt(searchResult.id),
    duration: searchResult.bag?.duration,
    thumbnailUrl: searchResult.bag?.thumbnailUrl,
    completionStatus: mapCompletionStatus(searchResult),
  } as ContentItem;
}
